import { Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'

const FieldError = ({ msg }: { msg: string }) => {
  return (
    <Typography variant='body1' sx={errorSx}>
      {msg}
    </Typography>
  )
}

export const errorSx = { color: '#E01717', textAlign: 'center' }

export default observer(FieldError)
